import dattoLogo from '../../../../images/cc/datto_autotask_psa_logo.png';
import autotaskIcon from '../../../../images/cc/autotask-24x24.png';

import { createDefaultService } from '../../services';
import CredentialsView from './CredentialsView';

export default {
    name: 'autotaskpsa',
    label: 'DATTO Autotask',
    agreementLabel: 'Contract',
    enabled: true,
    visible: true,
    logo: dattoLogo,
    icon: autotaskIcon,
    guide_url: 'datto_autotask_setup_guide_url',
    components: {
        CredentialsView,
    },
    serviceProvider: createDefaultService('autotaskpsa'),
    methods: {
        isInstalled(service) {
            return !!(service && service.extra && service.extra.username);
        },
    },
};
